import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICourseHoursRange } from '.';

const apiDataProvider = new APIDataProvider();

// eslint-disable-next-line import/prefer-default-export
export const getCourseHoursRange = createAsyncThunk(
  '/course-hours-ranges/get-one',
  async () => {
    const path = `${ApiPaths.settings}/hours-range`;
    const response = await apiDataProvider.get<TApiResponse<ICourseHoursRange>>(
      path
    );
    return response.data;
  }
);
